import { CopyableEntry } from '@dittolive/anvil'
import React from 'react'

type Props = {
  /**
   * The auth/HTTP URL for the connection
   */
  authUrl?: string
  /**
   * The WebSocket URL for the connection
   */
  websocketUrl?: string
  /**
   * Whether to use renamed terminology (URL vs Auth URL)
   */
  isRenamed?: boolean
}

/**
 * Displays connection URLs (Auth URL and WebSocket URL) with copy functionality.
 */
export default function ConnectionURLs({
  authUrl,
  websocketUrl,
  isRenamed = false,
}: Props) {
  if (!authUrl) return null

  const authUrlText = isRenamed ? 'URL' : 'Auth URL'

  return (
    <>
      <CopyableEntry
        value={authUrl}
        title={authUrlText}
        testId="appAuthURL"
        isCode
      />

      {!isRenamed && websocketUrl && (
        <CopyableEntry
          value={websocketUrl}
          title="Websocket URL"
          testId="appWsURL"
          isCode
        />
      )}
    </>
  )
}
